import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';
import { PaymentMethodDropdown } from '../../../components/paymentMethodDropdown/PaymentMethodDropdown';
import { WorldpayNewCardFrame } from './WorldpayNewCardFrame';
import { WorldpaySavedCardFrame } from './WorldpaySavedCardFrame';
import { WorldpayFrameWrapper, WorldpaySavedMethodsWrapper } from './WorldpayTab.style';
import { WorldpayPaymentMethodType, WorldpayTabState } from './WorldpayTab.state';

interface WorldpayFramePropsType {
    state: WorldpayTabState;
    hidden: boolean;
    paymentMethod: WorldpayPaymentMethodType;
}

export const WorldpayFrame = observer(
    'WorldpayFrame',
    ({ state, hidden, paymentMethod }: WorldpayFramePropsType): JSX.Element => {
        const common = useCommon();
        const { worldpayCheckout } = EnvironmentState.get(common).emotionTheme.star;

        const showSavedCardFlow =
            paymentMethod === 'debit-card' &&
            state.selectedSavedPaymentMethodId !== 'none' &&
            state.selectedSavedPaymentMethod?.providerReference !== undefined &&
            state.selectedSavedPaymentMethod?.providerReference !== null &&
            state.selectedSavedPaymentMethod?.providerReference !== '';

        const styles: Record<string, Record<string, string>> = {};
        if (worldpayCheckout.input.color !== '') {
            styles.input = {
                ...(worldpayCheckout.input.color ? { color: worldpayCheckout.input.color } : {}),
                ...(worldpayCheckout.input.fontSize ? { 'font-size': worldpayCheckout.input.fontSize } : {}),
                ...(worldpayCheckout.input.fontWeight ? { 'font-weight': worldpayCheckout.input.fontWeight } : {}),
            };
        }
        if (worldpayCheckout.inputValid.color !== '') {
            styles['input.is-valid'] = { color: worldpayCheckout.inputValid.color };
        }
        if (worldpayCheckout.inputInvalid.color !== '') {
            styles['input.is-invalid'] = { color: worldpayCheckout.inputInvalid.color };
        }
        if (worldpayCheckout.inputFocus.color !== '') {
            styles['input.is-onfocus'] = { color: worldpayCheckout.inputFocus.color };
        }

        if (paymentMethod === 'debit-card') {
            return (
                <WorldpayFrameWrapper hidden={hidden}>
                    <WorldpaySavedMethodsWrapper>
                        <PaymentMethodDropdown
                            label='Saved payment methods'
                            options={state.depositSavedPaymentMethods}
                            value={state.selectedSavedPaymentMethodId}
                            onChangeCB={state.handleSavedPaymentMethodChange}
                            refreshPaymentMethods={state.loadSavedPaymentMethods}
                            allowAddingMethod
                        />
                    </WorldpaySavedMethodsWrapper>

                    {showSavedCardFlow ? (
                        <WorldpaySavedCardFrame
                            state={state}
                            hidden={hidden}
                            paymentMethod={paymentMethod}
                        />
                    ) : (
                        <WorldpayNewCardFrame
                            state={state}
                            hidden={hidden}
                            paymentMethod={paymentMethod}
                        />
                    )}
                </WorldpayFrameWrapper>
            );
        }

        return <></>;
    }
);
